# please pardon me for this too simple code, it is an example on how to use this workflow framework
React = require('react/addons')
Router = require('react-router')
{ Route, RouteHandler, Link } = Router
LocalStorageUtil = require('../utils/LocalStorage')
# TransitionGroup = React.addons.CSSTransitionGroup

LOCAL_STORAGE_PREFIX = 'wff' 

LocalStorageUtil.init(LOCAL_STORAGE_PREFIX)

module.exports = React.createClass
  # mixins: [ Router.State ]
  render: ->
    React.createElement("div", null,
        React.createElement("header", {"className": "header"},
            React.createElement("div", {"className": "logo-container"},
                React.createElement("img", {"className": "icon-i-roy logo center-block", "src": "images/logo.png"}),
                React.createElement("div", {"className": "banner"},
                    React.createElement("p", {"dangerouslySetInnerHTML": ({__html: 'The x32 ABI (libx32) packages<br />for ArchLinux <span>_</span>'})})
                ),
                React.createElement("div", {"className": "nav", "activeClassName": "active"},
                    React.createElement(Link, {"to": "about"}, """
                        About
"""),
                    React.createElement(Link, {"to": "examples", "activeClassName": "active"}, """
                        Build
""")
                )
            )
        ),
        React.createElement("div", {"className": "container"},
            React.createElement("section", {"className": "page-content"},
                React.createElement(RouteHandler, null)
            )
        ),
        React.createElement("footer", null,
            React.createElement("div", {"className": "content"}, """
                I\'m Fantix King, a Python developer. """, React.createElement("a", {"href": "https://www.linkedin.com/in/fantix"}, "Hire me"),
                React.createElement("div", {"className": "large"}, "~\u2661\u24db\u24de\u24e5\u24d4\u2661~")
            )
        )
    )



/** WEBPACK FOOTER **
 ** ./~/cjsx-loader!./src/scripts/components/app.cjsx
 **/